import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./product/productSlice";
import userReducer from "./user/userSlice";
import configurationReducer from "./userConfiguration/configurationSlice";

export const store = configureStore({
  reducer: {
    configuration: configurationReducer,
    user: userReducer,
    product: productReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
